import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import urlHelper from '@/router/urlHelper';


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryProductFacetFilteringDropdown',
  props: {
    facet: null,
    values: null
  },
  setup(__props: any) {

const props = __props as {
    facet: FacetViewObject,
    values: FacetValueViewObject[]
}



const selectedFacets = computed<FacetValueViewObject[]>({
    get() {
        return props.values.filter(value => value.selected);
    },
    set(value: FacetValueViewObject[]) {
        urlHelper.setFacetValues(props.facet.facetId, value.map(x => x.key), true);
    }
});

return { __sfc: true,props, selectedFacets }
}

})